import useSWR from "swr";
import useUser from "../../context/userHook";

import { getItemSettings, updateItemSettings } from "../../../utils/requests/itemSettingsRequest";
import useTokenHook from "../../context/useTokenHook";
import logger from "../../../lib/logger";
import mondaySdk from "monday-sdk-js";

const monday = mondaySdk();
export const useItemSettings = (itemIds: string[]) => {
  const { userId } = useUser();
  const { token } = useTokenHook();

  const { isLoading, error, data, mutate } = useSWR(token && userId && itemIds.length > 0 ? `itemSettings:${userId}:${itemIds}` : null, () =>
    getItemSettings(token!, itemIds)
  );

  const updateSettings = async (settingKey: string, checked: boolean) => {
    try {
      await updateItemSettings(token!, settingKey, itemIds[0], checked);
      mutate();

      monday.execute("notice", {
        message: `${settingKey === "sharedUpdates" ? "Shared Updates" : "Shared Subitems"} has been ${checked ? "enabled" : "disabled"}`,
        type: "success",
        timeout: 5000,
      });
    } catch (error: any) {
      logger.error(error.message);
    }
  };

  return {
    userId,
    itemIds,
    itemSettingsLoading: isLoading,
    error,
    itemSettings: data || {},
    updateSettings,
  };
};

export default useItemSettings;
